<div class="bg-color-base-3100 h-100vh">
    <grid-row class="justify-content-center align-content-center h-100">
        <grid-col col="6" mobile="11" class="text-align-center">
            <ng-icon iconClass="icon-review-success" width="100" height="100"></ng-icon>
            <div class="h-400">
                <grid-row class="justify-content-center align-content-between h-100">
                    <grid-col col="12">
                        <div class="font-500 font-size-32px color-base-2200 line-h-40 mt-40">
                            {{ "ApplicationUnderReview" | translate }}
                        </div>
                        <div class="font-400 font-size-20px color-base-700 mt-10">
                            {{ "NotifiedBusinessDays" | translate }}
                        </div>
                    </grid-col>
                    <grid-col col="12">
                        <grid-row class="justify-content-center mt-50">
                            <grid-col col="8">
                                <button class="btn-dft-border" (click)="dashboard()">
                                    {{ "BACKTODASHBOARD" | translate }}
                                </button>
                            </grid-col>
                        </grid-row>
                    </grid-col>
                </grid-row>
            </div>
        </grid-col>
    </grid-row>
</div>